import { FC, useEffect } from 'react';
import {
  Center,
  Heading,
  VStack,
  Button,
  Box,
  Flex,
  Spinner,
} from '@chakra-ui/react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { FaPlus } from 'react-icons/fa';
import VariantsTable from './Table';
import { useAdminCardDecksTraits, useAdminCardDecksVariants } from '@olagg/api-hooks';

const Variants: FC = () => {
  const navigate = useNavigate();
  const { deck_id, trait_id } = useParams();

  if (!deck_id || !trait_id) return null;

  const { data, isLoading, mutate } = useAdminCardDecksVariants(deck_id, trait_id);
  const { trait, isLoading: isLoadingTrait, find } = useAdminCardDecksTraits(deck_id);

  useEffect(() => {
    find(trait_id);
  }, [trait_id]);
  
  if (isLoading || isLoadingTrait) return <Spinner>Cargando...</Spinner>; 
  
  return (
    <Center w='full' pb={4}>
      <VStack color={'white'} w='full'>
        <Heading my={2}>Variantes de {`${trait?.name || 'Traits'}`}</Heading>
        <Flex w='full' alignItems='center' justifyContent='space-between'>
          <Button
            mt='2'
            variant="outlinedGradient"
            leftIcon={<FaPlus />}
            onClick={() => navigate(generatePath(ROUTES.CARD_DECKS.variants.create, { deck_id, trait_id }))}
          >
            Nueva Variante
          </Button>
        </Flex>

        {isLoading ? (
          <Spinner />
        ) : (
          <Box overflow="auto" mt={4} w="80vw" h="65vh">
            <VariantsTable variants={data?.variants || []} onUpdate={mutate} />
          </Box>
        )}
      </VStack>
    </Center>
  );
};

export default Variants;
export { CreateVariant } from './Create';
export { EditVariant } from './Edit';
